import { gql, useMutation } from '@apollo/client';

import {
  AcceptLead,
  AcceptLeadVariables,
} from '../../../graphql/athena/mutations/__generated__/AcceptLead';
import { LWC_DETAILS_FOR_BROKERAGE_QUERY } from '../queries/BrokerageLwcDetails';
import { LWC_DETAILS_QUERY } from '../queries/LwcDetails';
import { PARN_DETAILS_QUERY } from '../queries/ParnDetails';

export const ACCEPT_LISTING_LEAD = gql`
  mutation AcceptLead($agentCustomerUuid: String!, $agentListingLeadId: String!) {
    odProtosAgentsServicesAgentlead {
      acceptLead(input: { agentLeadId: $agentListingLeadId, agentCustomerId: $agentCustomerUuid }) {
        lead {
          id
        }
      }
    }
  }
`;

/**
 * Previous state: LISTING_INITIATED
 * transitions to state: AGENT_ASSIGNED
 * Required before any of the other states can be transitioned to.
 * Rejecting removes the lead from the agent's queue.
 */
export const useAcceptListingLead = () => {
  const [acceptListingLead, { data, error, loading }] = useMutation<
    AcceptLead,
    AcceptLeadVariables
  >(ACCEPT_LISTING_LEAD, {
    fetchPolicy: 'no-cache',
    context: {
      clientName: 'athena',
    },
    refetchQueries: [LWC_DETAILS_QUERY, LWC_DETAILS_FOR_BROKERAGE_QUERY, PARN_DETAILS_QUERY],
  });
  const acceptLead = async (agentCustomerUuid: string, agentListingLeadId: string) =>
    await acceptListingLead({
      variables: { agentCustomerUuid, agentListingLeadId },
    });
  return { acceptLead, data, loading, error };
};
